import { useNavigate, Link, useLocation } from 'react-router-dom';
import { AccessContext } from '../components/context.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptop, faMicrophoneAlt, faShirt, faTicket, faRectangleAd, faChevronRight, faBank } from '@fortawesome/free-solid-svg-icons'
import { faCalendarDays, faRectangleList, faIdCard, faAddressCard } from '@fortawesome/free-regular-svg-icons'
import { useState, useContext, useEffect } from 'react';

const SideNav = () => {
    const access = useContext(AccessContext);
    const [openDD, setOpenDD] = useState([false, false, false, false, false, false]);
    const { role, isSuper, podcastMetaData, isHosted } = useContext(AccessContext);
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const logout = () => {
        localStorage.removeItem('jwt');
        navigate('/login');
    }
    const toggleDD = (i) => {
        setOpenDD(dd => {
            var _dd = [...dd];
            _dd[i] = !_dd[i];
            return _dd;
        });
    }
    useEffect(() => {
        switch (pathname) {
            case '/episode-list':
            case '/episode':
                setOpenDD([true, false, false, false, false, false]);
                break;
            case '/host-list':
            case '/host':
            case '/guest-list':
            case '/guest':
                if (access.role == 'Host/Guest')
                    setOpenDD([false, false, false, false, true, false]);
                else
                    setOpenDD([false, true, false, false, false, false]);
                break;
            case '/merch-list':
            case '/merch':
                setOpenDD([false, false, true, false, false, false]);
                break;
            case '/event-list':
            case '/event':
                setOpenDD([false, false, false, true, false, false]);
                break;
            case '/sponsor-list':
            case '/sponsor':
                setOpenDD([false, false, false, false, true, false]);
                break;
            case '/image-list':
            case '/video-list':
            case '/link-list':
                setOpenDD([false, false, false, false, false, true]);
                break;
        }
    }, []);
    const episodePaths = ['/episode-list', '/episode'];
    const hostGuestPaths = ['/host-list', '/host', '/guest-list', '/guest', '/manage-profiles'];
    const merchPaths = ['/merch-list', '/merch'];
    const eventPaths = ['/event-list', '/event', '/past-events'];
    const sponsorPaths = ['/sponsor-list', '/sponsor'];
    const hostGuestAccountPaths = ['/host'];
    const mediaPaths = ['/image-list', '/image', '/video-list', '/video', '/link-list', '/link'];
    return (
        <>
            <nav className="f-col f-start pt-30 pb-30 pr-20 pl-20 flex gap-20 side-nav">
                <Link className={"dashboard-item w-100" + (pathname == '/' ? ' active' : '')} style={{maxWidth: '100%'}} to="/">
                    <div className="flex a-start">
                        <FontAwesomeIcon icon={faLaptop} />
                        <span>Dashboard</span>
                    </div>
                </Link>
                {role != "Host/Guest" && !isHosted ? (
                    <div className={"dropdown-container" + (openDD[0] ? ' active' : '')}>
                        <div className={"flex w-100 a-start dashboard-item" + (episodePaths.includes(pathname) ? ' active' : '')} role="button" onClick={() => toggleDD(0)}>
                            <FontAwesomeIcon icon={faMicrophoneAlt} />
                            <span>{role == "Host/Guest" ? "My Episodes" : "Episodes"}</span>
                            <FontAwesomeIcon icon={faChevronRight} className="ml-auto" />
                        </div>
                        <div className="dropdown-menu h-1">
                            <Link className={pathname == '/episode-list' && 'active'} to="/episode-list">View All Episodes</Link>
                            <Link className={pathname == '/episode' && 'active'} to="/episode">Create Episode</Link>
                        </div>
                    </div>
                ) : (
                    <Link className={"dashboard-item w-100" + (pathname == '/episode-list' ? ' active' : '')} style={{maxWidth: '100%'}} to="/episode-list">
                        <div className="flex a-start">
                            <FontAwesomeIcon icon={faMicrophoneAlt} />
                            <span>{role == "Host/Guest" ? "My Episodes" : "Episodes"}</span>
                        </div>
                    </Link>
                )}
                {role != 'Host/Guest' && (
                    <div className={"dropdown-container" + (openDD[1] ? ' active' : '')}>
                        <div className={"flex w-100 a-start dashboard-item" + (hostGuestPaths.includes(pathname) ? ' active' : '')} role="button" onClick={() => toggleDD(1)}>
                            <FontAwesomeIcon icon={faIdCard} />
                            <span>Hosts & Guests</span>
                            <FontAwesomeIcon icon={faChevronRight} className="ml-auto" />
                        </div>
                        <div className="dropdown-menu h-1">
                            <Link className={pathname == '/host-list' && 'active'} to="/host-list">View All Hosts</Link>
                            {/*<Link className={pathname == '/host' && 'active'} to="/host">Create Host</Link>*/}
                            <Link className={pathname == '/guest-list' && 'active'} to="/guest-list">View All Guests</Link>
                            {/*<Link className={pathname == '/guest' && 'active'} to="/guest">Create Guest</Link>*/}
                        </div>
                    </div>
                )}
                {role == 'Host/Guest' && (
                    <Link className={"dashboard-item w-100" + (pathname == '/media' ? ' active' : '')} style={{maxWidth: '100%'}} to="/media">
                        <div className="flex a-start">
                            <FontAwesomeIcon icon={faAddressCard} />
                            <span>Media & Links</span>
                        </div>
                    </Link>
                )}
                {access.merch && <div className={"dropdown-container" + (openDD[2] ? ' active' : '')}>
                    <div className={"flex w-100 a-start dashboard-item" + (merchPaths.includes(pathname) ? ' active' : '')} role="button" onClick={() => toggleDD(2)}>
                        <FontAwesomeIcon icon={faShirt} />
                        <span>Merch & Products</span>
                        <FontAwesomeIcon icon={faChevronRight} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-1">
                        <Link className={pathname == '/merch-list' && 'active'} to="/merch-list">View All Merch</Link>
                        <Link className={pathname == '/merch' && 'active'} to="/merch">Create Merch</Link>
                    </div>
                </div>}
                {access.events && <div className={"dropdown-container" + (openDD[3] ? ' active' : '')}>
                    <div className={"flex w-100 a-start dashboard-item" + (eventPaths.includes(pathname) ? ' active' : '')} role="button" onClick={() => toggleDD(3)}>
                        <FontAwesomeIcon icon={faCalendarDays} />
                        <span>Events & Tickets</span>
                        <FontAwesomeIcon icon={faChevronRight} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-3">
                        <Link className={pathname == '/event-list' && 'active'} to="/event-list">View All Events</Link>
                        <Link className={pathname == '/past-events' && 'active'} to="/past-events">View Past Events</Link>
                        <Link className={pathname == '/event' && 'active'} to="/event">Create Event</Link>
                    </div>
                </div>}
                {access.sponsors && role != 'Host/Guest' && <div className={"dropdown-container" + (openDD[4] ? ' active' : '')}>
                    <div className={"flex w-100 a-start dashboard-item" + (sponsorPaths.includes(pathname) ? ' active' : '')} role="button" onClick={() => toggleDD(4)}>
                        <FontAwesomeIcon icon={faRectangleAd} />
                        <span>Podcast Sponsors</span>
                        <FontAwesomeIcon icon={faChevronRight} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-1">
                        <Link className={pathname == '/sponsor-list' && 'active'} to="/sponsor-list">View All Sponsors</Link>
                        <Link className={pathname == '/sponsor' && 'active'} to="/sponsor">Create Sponsor</Link>
                    </div>
                </div>}
                {role != 'Host/Guest' && (
                    <Link className={"dashboard-item w-100" + (pathname == '/media' ? ' active' : '')} style={{maxWidth: '100%'}} to="/media">
                        <div className="flex a-start">
                            <FontAwesomeIcon icon={faAddressCard} />
                            <span>Media & Links</span>
                        </div>
                    </Link>
                )}
                {role != "Host/Guest" ? (
                    <Link className={"dashboard-item w-100" + (pathname == '/podcast-settings' ? ' active' : '')} style={{maxWidth: '100%'}} to="/podcast-settings">
                        <div className="flex w-100 a-start">
                            <FontAwesomeIcon icon={faRectangleList} />
                            <span>Podcast Settings</span>
                        </div>
                    </Link>
                ) : (<div className={"dropdown-container" + (openDD[4] ? ' active' : '')}>
                    <div className={"flex w-100 a-start dashboard-item" + (hostGuestAccountPaths.includes(pathname) ? ' active' : '')} role="button" onClick={() => toggleDD(4)}>
                        <FontAwesomeIcon icon={faRectangleList} />
                        <span>Profile Settings</span>
                        <FontAwesomeIcon icon={faChevronRight} className="ml-auto" />
                    </div>
                    <div className="dropdown-menu h-1">
                        <Link className={pathname == '/host' && 'active'} to="/host">Profile Info</Link>
                        {!isSuper && <Link className={pathname == '/billing' && 'active'} to="/billing">Billing Info</Link>}
                    </div>
                </div>
                )}
                {role == "Podcast" && !isSuper && (
                    <Link className={"dashboard-item w-100" + (pathname == '/billing' ? ' active' : '')} style={{maxWidth: '100%'}} to="/billing">
                        <div className="flex w-100 a-start">
                            <FontAwesomeIcon icon={faBank} />
                            <span>Billing</span>
                        </div>
                    </Link>
                )}
            </nav>
        </>
    );
}

export default SideNav;